import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    display: 'block',

    width: 'fit-content',

    marginTop: '0.25rem',
});
